(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["schoolstore-category-sidebar"] && !Shopify.designMode) return;
  try {
    const categoryScreen = window.matchMedia('(min-width: 990px)');
const updateCategoryNavigation = () => document.querySelectorAll('.ss-categories details').forEach(item => { item.open = categoryScreen.matches; });
updateCategoryNavigation();
categoryScreen.addEventListener('change', updateCategoryNavigation);
  } catch(e) { console.error(e); }
})();

})();
